<script setup lang="ts">
import InlineNotification from '@/components/notifications/InlineNotification.vue';
import { toRef } from 'vue';
import { useDeviceStatusSignalR } from './utils/useDeviceStatusSignalR';
import { useDeviceError } from './utils/useDeviceMessages';
import DeviceErrorDialog from './DeviceErrorDialog.vue';
import { useToggle } from '@vueuse/core';
import { QaEquipmentCatalogDto, QaEquipmentRtSystemDto } from '@/api/generator';

const props = defineProps<{
  device: QaEquipmentRtSystemDto | QaEquipmentCatalogDto;
  withDetailsLink: boolean;
}>();

const deviceState = useDeviceStatusSignalR(toRef(() => props.device.id));

const { notifications, highestSeverityMessage, highestSeverityNotification, hasMessageDetails } =
  useDeviceError(deviceState);

const [isDialogOpen, openDialog] = useToggle(false);
</script>

<template>
  <InlineNotification :value="highestSeverityNotification" v-bind="$attrs">
    <template #append>
      <a
        v-if="withDetailsLink && hasMessageDetails(highestSeverityMessage)"
        class="cursor-pointer"
        @click="openDialog()"
      >
        details
      </a>
    </template>
  </InlineNotification>

  <DeviceErrorDialog
    v-if="highestSeverityMessage"
    v-model:open="isDialogOpen"
    :notifications="notifications"
    :deviceId="device.id"
  />
</template>
